<div class="tasks-list">

  <!-- Task rows -->
  <div class="task-row" *ngFor="let subtask of subtasks">
    <div class="task-main">
      <input
        type="checkbox"
        class="task-checkbox"
        [checked]="subtask.isDone"
        (change)="toggleSubtask(subtask._id)"
        [disabled]="!canEdit">

      <input
        *ngIf="canEdit && editingTaskId === subtask._id; else taskTextDisplay"
        class="task-text-input"
        type="text"
        [(ngModel)]="editingTaskText"
        (keyup.enter)="saveTextEdit(subtask)"
        (keyup.escape)="cancelTextEdit()"
        (blur)="saveTextEdit(subtask)">
      <ng-template #taskTextDisplay>
        <span
          class="task-text"
          [class.done]="subtask.isDone"
          [class.editable]="canEdit"
          (click)="canEdit && startTextEdit(subtask)">{{ subtask.description }}</span>
      </ng-template>

      <!-- Inline delete confirm -->
      <ng-container *ngIf="confirmingDeleteId === subtask._id; else taskActions">
        <span class="confirm-label">{{ 'request_v2.subtasks.confirm_delete' | translate }}</span>
        <button type="button" class="confirm-yes" (click)="executeDelete(subtask._id)">
          {{ 'request_v2.subtasks.confirm_yes' | translate }}
        </button>
        <button type="button" class="confirm-no" (click)="confirmingDeleteId = null">
          {{ 'request_v2.subtasks.confirm_no' | translate }}
        </button>
      </ng-container>

      <ng-template #taskActions>
        <!-- Due date pill (editable) -->
        <button
          type="button"
          class="due-pill"
          [class.has-date]="!!subtask.dueDate"
          [class.due-past]="subtask.dueDate && getDueStatus(subtask.dueDate) === 'past'"
          [class.due-soon]="subtask.dueDate && getDueStatus(subtask.dueDate) === 'soon'"
          *ngIf="canEdit"
          (click)="$event.stopPropagation(); openDueDatePicker(subtask._id)">
          <mat-icon>calendar_today</mat-icon>
          <span>{{ subtask.dueDate ? formatDueDate(subtask.dueDate) : ('request_v2.subtasks.due_date' | translate) }}</span>
        </button>

        <!-- Due date (read-only) -->
        <span
          class="due-pill has-date"
          [class.due-past]="subtask.dueDate && getDueStatus(subtask.dueDate) === 'past'"
          [class.due-soon]="subtask.dueDate && getDueStatus(subtask.dueDate) === 'soon'"
          *ngIf="!canEdit && subtask.dueDate">
          <mat-icon>calendar_today</mat-icon>
          {{ formatDueDate(subtask.dueDate) }}
        </span>

        <!-- Assignee (editable) -->
        <div class="task-assignee"
             *ngIf="canEdit"
             [class.assigned]="!!subtask.assignedTo"
             [class.loading]="assigningSubtaskId === subtask._id"
             (click)="openAssigneeMenu($event, subtask._id, subtask)">
          <ng-container *ngIf="subtask.assignedTo; else noAssignee">
            <img *ngIf="subtask.assignedTo.picture" [src]="subtask.assignedTo.picture" alt="">
            <span *ngIf="!subtask.assignedTo.picture" class="initials">{{ getAssigneeInitials(subtask.assignedTo) }}</span>
          </ng-container>
          <ng-template #noAssignee>
            <mat-icon class="person-add-icon">person_add</mat-icon>
          </ng-template>
        </div>

        <!-- Assignee (read-only) -->
        <div class="task-assignee assigned" *ngIf="!canEdit && subtask.assignedTo">
          <img *ngIf="subtask.assignedTo.picture" [src]="subtask.assignedTo.picture" alt="">
          <span *ngIf="!subtask.assignedTo.picture" class="initials">{{ getAssigneeInitials(subtask.assignedTo) }}</span>
        </div>

        <!-- Delete trigger -->
        <button
          type="button"
          class="delete-btn"
          *ngIf="canEdit"
          (click)="$event.stopPropagation(); confirmingDeleteId = subtask._id">
          <mat-icon>close</mat-icon>
        </button>
      </ng-template>
    </div>

    <!-- Completion sub-row -->
    <div class="task-meta" *ngIf="subtask.isDone && subtask.completedAt">
      <span>{{ 'request_v2.subtasks.completed_at' | translate }} {{ subtask.completedAt | date:('request_v2.info.internal_note_date_format' | translate):undefined:currentLocale }}</span>
      <button
        type="button"
        class="meta-btn"
        *ngIf="canEdit"
        [disabled]="updatingCompletedAtSubtaskId === subtask._id"
        (click)="prepareCompletedAtEdit(subtask)">
        <mat-icon>edit</mat-icon>
      </button>
    </div>
  </div>

  <!-- Inline creation row -->
  <div class="task-row new-task-row" *ngIf="canEdit && isAdding">
    <div class="task-main">
      <input type="checkbox" class="task-checkbox" disabled>
      <input
        #newTaskInput
        type="text"
        class="task-input"
        [placeholder]="'request_v2.subtasks.add_placeholder' | translate"
        [(ngModel)]="newSubtaskDescription"
        (keyup.enter)="createSubtask()"
        (keyup.escape)="dismissAdding()">
      <button
        type="button"
        class="due-pill"
        [class.has-date]="!!newDueDate"
        (click)="$event.stopPropagation(); openDueDatePicker('new')">
        <mat-icon>calendar_today</mat-icon>
        <span>{{ newDueDate ? formatDueDate(newDueDate) : ('request_v2.subtasks.due_date' | translate) }}</span>
      </button>
      <div class="task-assignee"
           [class.assigned]="!!selectedAssignee"
           (click)="openAssigneeMenu($event, 'new')">
        <ng-container *ngIf="selectedAssignee; else noNewAssignee">
          <img *ngIf="selectedAssignee.picture" [src]="selectedAssignee.picture" alt="">
          <span *ngIf="!selectedAssignee.picture" class="initials">{{ selectedAssignee.name | slice:0:2 }}</span>
        </ng-container>
        <ng-template #noNewAssignee>
          <mat-icon class="person-add-icon">person_add</mat-icon>
        </ng-template>
      </div>
      <button
        type="button"
        class="create-btn"
        [disabled]="!newSubtaskDescription.trim() || isCreating"
        (click)="createSubtask()">
        {{ 'request_v2.subtasks.create' | translate }}
      </button>
    </div>
  </div>

</div>

<!-- Shared completion date picker (outside *ngFor so ViewChild resolves correctly) -->
<input *ngIf="canEdit" class="date-picker-hidden" [ngxMatDatetimePicker]="sharedCompletedAtPicker"
  (dateChange)="onCompletedAtDateChange($event)" readonly>
<ngx-mat-datetime-picker #sharedCompletedAtPicker [showSeconds]="false" [enableMeridian]="false"
  (closed)="onPickerClosed()">
</ngx-mat-datetime-picker>

<!-- Shared due date picker (date only) -->
<input *ngIf="canEdit" class="date-picker-hidden" [matDatepicker]="sharedDuePicker"
  (dateChange)="onDueDateChange($event)" readonly>
<mat-datepicker #sharedDuePicker>
  <mat-datepicker-actions>
    <button mat-button matDatepickerCancel (click)="clearDueDate()">
      {{ 'request_v2.subtasks.due_date_clear' | translate }}
    </button>
    <button mat-raised-button color="primary" matDatepickerApply>OK</button>
  </mat-datepicker-actions>
</mat-datepicker>

<!-- Add task trigger -->
<button
  type="button"
  class="add-task-btn"
  *ngIf="canEdit && !isAdding"
  (click)="isAdding = true">
  <mat-icon>add</mat-icon>
  {{ 'request_v2.subtasks.add_task' | translate }}
</button>

<app-subtask-assignee-menu
  #assigneeMenu
  (assigneeSelect)="onAssigneeSelected($event)"
  (close)="activeSubtaskId = null">
</app-subtask-assignee-menu>
